/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import Button from '@common_button';
import Typography from '@common_typography';
import cx from 'classnames';
import Skeleton from '@common_skeleton';
import ModalPickupInformation from '@core_modules/checkout/pages/default/components/ModalPickupInformation';
import ModalSelectStore from '@core_modules/checkout/pages/default/components/ModalSelectStore';
import gqlService from '@core_modules/checkout/services/graphql';
import { useSelector } from 'react-redux';
import {
    selectCheckoutState,
} from '@core_modules/checkout/redux/checkoutSlice';
import { useEffect } from 'react';
import UrbanIcon from '@core_modules/theme/plugins/urbanicon';

const PickupInformation = (props) => {
    const {
        t, formik, storeConfig, isOnlyVirtualProductOnCart, refetchDataCart, refetchItemCart, updateFormik, checkoutTokenState, setCheckoutTokenState,
    } = props;

    const checkout = useSelector(selectCheckoutState);
    const channel_code = storeConfig.oms_channel_code;

    const FILTER = {
        is_active: { eq: 1 },
        is_pickup_active: { eq: 1 },
        channel_name: { eq: channel_code },
    };
    const PAGE_SIZE = 200;
    const CURRENT_PAGE = 1;
    const generateSkuList = () => {
        const { items: cartItems } = checkout.data.cart;
        const skuListQuantity = cartItems.map((item) => ({
            sku: item.product.sku,
            qty: item.quantity,
        }));
        return skuListQuantity;
    };

    const pickupStoresOMS = gqlService.getTimeLocationListBySkus({
        variables: {
            skus: generateSkuList(),
            filter: FILTER,
            pageSize: PAGE_SIZE,
            currentPage: CURRENT_PAGE,
        },
    });

    let oms_store_list = [];
    if (!pickupStoresOMS.loading && pickupStoresOMS.data && !pickupStoresOMS.error) {
        oms_store_list = pickupStoresOMS.data.getTimeLocationListBySkus.items;
    }

    let formatted_oms_stores = [];
    if (oms_store_list.length > 0) {
        formatted_oms_stores = oms_store_list.map((item) => {
            const data_store = {
                code: item.loc_code,
                street: item.loc_street,
                city: item.loc_city.label,
                name: item.loc_name,
                region: item.loc_region.label,
                zone: item.loc_zone,
                telephone: item.loc_telephone,
                postcode: item.loc_postcode,
                lat: item.loc_lat,
                long: item.loc_long,
                country_id: item.loc_country.id,
                country: item.loc_country.label,
                opening_hours: item?.loc_operational_time || [],
                skus_not_available: item?.skus_not_available || [],
            };

            return data_store;
        });
    }

    const [openModal, setOpenModal] = React.useState({
        openModalInfo: false,
        openModalSelectStore: false,
    });
    const handleOpen = (state) => {
        setOpenModal({
            ...openModal,
            [state]: !openModal[state],
        });
    };

    const handleOpeningHours = (operation_time) => (
        <div className="opening_hours">
            {operation_time.map((time) => (
                <li className="list-none text-neutral-150 uppercase">
                    {`${time.day}: ${time.open_at} - ${time.close_at}`}
                </li>
            ))}
        </div>
    );

    useEffect(() => {
        if (!pickupStoresOMS.loading && pickupStoresOMS.error) {
            window.toastMessage({
                open: true,
                text: t('chekcout:pickupInformation:failedFetchStore'),
                variant: 'error',
            });
        }
    }, [pickupStoresOMS]);

    return (
        <div
            id="checkoutPickupStore"
            className={cx(
                'flex flex-col border-b border-b-neutral-200',
                'w-full py-6 gap-4',
            )}
        >
            <ModalPickupInformation
                open={openModal.openModalInfo}
                setOpen={() => handleOpen('openModalInfo')}
                checkout={checkout}
                isOnlyVirtualProductOnCart={isOnlyVirtualProductOnCart}
                refetchDataCart={refetchDataCart}
                refetchItemCart={refetchItemCart}
                updateFormik={updateFormik}
                checkoutTokenState={checkoutTokenState}
                setCheckoutTokenState={setCheckoutTokenState}
            />
            <ModalSelectStore
                open={openModal.openModalSelectStore}
                setOpen={() => handleOpen('openModalSelectStore')}
                checkout={checkout}
                listStores={formatted_oms_stores}
            />
            <Typography variant="bd-1" className="uppercase">
                {t('checkout:pickupInformation:label')}
            </Typography>
            <div className={cx(
                'border rounded-lg border-neutral-200',
                'max-w-lg p-4 mb-4',
            )}
            >
                <div className="flex flex-col gap-4">
                    {
                        (Object.keys(checkout.pickupInformation).length > 0 && checkout.pickupInformation?.pickup_person_name) && (
                            <>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>Person</td>
                                            <td>{' : '}</td>
                                            <td><strong>{checkout.pickupInformation.pickup_person_name}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>{t('common:form:phoneNumber')}</td>
                                            <td>{' : '}</td>
                                            <td><strong>{checkout.pickupInformation.pickup_person_phone}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>Email</td>
                                            <td>{' : '}</td>
                                            <td><strong>{checkout.pickupInformation.pickup_person_email}</strong></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </>
                        )
                    }
                    <Button
                        align="left"
                        variant="plain"
                        className="!p-0"
                        onClick={() => handleOpen('openModalInfo')}
                        disabled={
                            formik.values.email !== '' && formik.values.email !== formik.values.oldEmail
                        }
                    >
                        <Typography
                            variant="bd-3"
                            className={cx('uppercase', checkout?.pickupInformation?.pickup_person_name ? '!text-primary' : '')}
                        >
                            {t('checkout:pickupInformation:changePickupInformation')}
                        </Typography>
                    </Button>
                </div>
            </div>
            <Typography>
                {t('checkout:pickupInformation:pickupAtLabel')}
            </Typography>
            <div className={cx(
                'border rounded-lg border-neutral-200',
                'max-w-lg p-4 mb-4',
            )}
            >
                <div className="flex flex-col gap-4">
                    {
                        (Object.keys(checkout.selectStore).length > 0) && (
                            <>
                                <Typography variant="bd-2" type="bold" className="!text-[15px]">
                                    {checkout.selectStore.name}
                                </Typography>
                                <Typography className="!text-neutral-500 !text-[15px] !tracking-[.33px]">
                                    {checkout.selectStore.street}
                                    <br />
                                    {checkout.selectStore.city}
                                    <br />
                                    {checkout.selectStore.region}
                                    <br />
                                    {checkout.selectStore.country}
                                    <br />
                                    {checkout.selectStore.postcode}
                                    <br />
                                    {checkout.selectStore.telephone}
                                    <br />
                                    {checkout.selectStore.opening_hours.length > 0 ? (
                                        <div className="flex flex-row gap-x-3">
                                            <div>
                                                <UrbanIcon
                                                    iconContent='"\e946"'
                                                    fontSize={15}
                                                    width={15}
                                                    height={15}
                                                    className="!text-neutral-150 block mt-[6px]"
                                                />
                                            </div>
                                            {handleOpeningHours(checkout.selectStore.opening_hours)}
                                        </div>
                                    ) : null}
                                </Typography>
                            </>
                        )
                    }
                    {
                        pickupStoresOMS.loading || !pickupStoresOMS.data ? (
                            <Skeleton width={270} height={30} />
                        ) : (
                            <Button
                                align="left"
                                variant="plain"
                                className="!p-0"
                                onClick={() => handleOpen('openModalSelectStore')}
                                disabled={
                                    formik.values.email !== '' && formik.values.email !== formik.values.oldEmail
                                }
                            >
                                <Typography
                                    variant="bd-3"
                                    className={cx('uppercase', (checkout.selectStore && checkout.selectStore.length) ? '!text-primary' : '')}
                                >
                                    {t('checkout:pickupInformation:changePickupLocation')}
                                </Typography>
                            </Button>
                        )
                    }
                </div>
            </div>
        </div>
    );
};

export default PickupInformation;
